import React, { useContext, useEffect, useRef } from "react";
import Interview from "./Interview";
import useFetchQuestion from "../../Hooks/Interview/useFetchQuestion";
import {
  InterviewQuestionError,
  QuestionLoading,
} from "../../constents/components";
import { InterviewContext } from "../../Contexts/InterviewContext";
import PopUp from "./PopUp";
import ExpiredPopUp from "./ExpiredPopUp";

const InterviewScreen = () => {
  const {
    applicantId,
    jobId,
    questionIndex,
    setQuestionIndex,
    totalQuestions,
    setTotalQuestions,
    isInterviewCompleted,
    updateInterviewStatusToEnd,
    consentAccepter,
  } = useContext(InterviewContext);

  const [loading, error, question, fetchQuestion, isExpired] =
    useFetchQuestion();
  const skipNextFetchRef = useRef(false);

  useEffect(() => {
    if (isInterviewCompleted) return;
    // Don't re-fetch once we know we're on the last question
    if (totalQuestions !== null && questionIndex + 1 > totalQuestions) return;

    if (skipNextFetchRef.current) {
      skipNextFetchRef.current = false;
      return;
    }

    const load = async () => {
      try {
        const result = await fetchQuestion(applicantId, jobId);

        if (!result?.ok) {
          if (result?.interviewDone) {
            updateInterviewStatusToEnd();
          }
          return;
        }

        const { currentQuestion, total_questions } = result.data;

        if (
          typeof currentQuestion !== "number" ||
          typeof total_questions !== "number"
        ) {
          console.error("Unexpected question API response:", result.data);
          return;
        }

        if (totalQuestions === null) {
          setTotalQuestions(total_questions);
        }

        if (currentQuestion > total_questions) {
          updateInterviewStatusToEnd();
          return;
        }

        if (currentQuestion > 1 && questionIndex === 0) {
          skipNextFetchRef.current = true;
          consentAccepter();
          setQuestionIndex(currentQuestion - 1);
        }
      } catch (err) {
        console.error("Failed to load interview question:", err);
      }
    };

    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionIndex, isInterviewCompleted]);

  // if (isExpired) return <ExpiredPopUp />;
  if (isInterviewCompleted) return <PopUp />;
  if (loading) return <QuestionLoading />;
  if (error) return <InterviewQuestionError />;

  return <Interview questionData={question} />;
};

export default InterviewScreen;
